import React, { Component } from "react";
import PropTypes from "prop-types";
import InfoIconSvg from "../assets/icon-info.svg";
import { OverlayTrigger, Image, Tooltip } from "react-bootstrap";

export default class TooltipComponent extends Component {
  render() {
    const {
      content,
      placement,
      id = "",
      classes = "",
      smallIconInfo = null
    } = this.props;
    return (
      <OverlayTrigger
        defaultShow={false}
        placement={placement}
        overlay={
          <Tooltip id={`tooltip-${id}`} className={classes}>
            {content}
          </Tooltip>
        }
      >
        <Image
          src={smallIconInfo ? smallIconInfo : InfoIconSvg}
          alt="Info Icon"
          className={
            !smallIconInfo ? "info-icon-tooltip" : "issue-info-icon-tooltip"
          }
        />
      </OverlayTrigger>
    );
  }
}

TooltipComponent.propTypes = {
  content: PropTypes.string.isRequired
};
